import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ steps, currentStep, completedSteps, onStepClick }) => {
  return (
    <div className="progress-indicator mb-8">
      <div className="flex items-center justify-between max-w-4xl mx-auto">
        {steps?.map((step, index) => {
          const isActive = index === currentStep;
          const isCompleted = completedSteps?.includes(index);
          const isClickable = index <= currentStep || isCompleted;

          return (
            <React.Fragment key={step?.id}>
              <button
                onClick={() => isClickable && onStepClick(index)}
                disabled={!isClickable}
                className={`flex flex-col items-center gap-2 transition-all ${
                  isClickable ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'
                }`}
              >
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center transition-all ${
                    isActive
                      ? 'bg-blue-600 shadow-warm-lg scale-110'
                      : isCompleted
                      ? 'bg-emerald-500 shadow-warm-md'
                      : 'bg-gray-300'
                  }`}
                >
                  {isCompleted && !isActive ? (
                    <Icon name="check" size={24} className="text-white" />
                  ) : (
                    <Icon name={step?.icon} size={24} className="text-white" />
                  )}
                </div>
                <span
                  className={`text-xs font-medium text-center max-w-[80px] ${
                    isActive ? 'text-blue-600' : isCompleted ? 'text-emerald-600' : 'text-gray-500'
                  }`}
                >
                  {step?.title?.split(' ')?.[0]}
                </span>
              </button>
              {index < steps?.length - 1 && (
                <div
                  className={`flex-1 h-1 mx-2 rounded transition-all ${
                    completedSteps?.includes(index) ? 'bg-emerald-500' : 'bg-gray-300'
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressIndicator;